import { render } from "./LetsTalk.vue?vue&type=template&id=01842eea"
import script from "./LetsTalk.vue?vue&type=script&lang=js"
export * from "./LetsTalk.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__